// The speaking aura's brightness, kept separate and pure so the photosensitivity
// limit is enforced by a test rather than by eye.
//
// The aura is a glow around the WHOLE screen edge. If it followed her voice
// syllable by syllable it would flash at 4-5 Hz, and WCAG 2.3.1 - the rule that
// exists for photosensitive epilepsy - allows at most three flashes in any one
// second. So the voice level goes through a slow first-order envelope (which
// leaves nothing faster than about 2 Hz with any strength), and the result only
// moves the opacity within a narrow band.

export const AURA_TAU = 0.4; // seconds
export const AURA_BASE = 0.7; // opacity while she speaks at all
export const AURA_SWING = 0.18; // extra opacity at full voice

// One step of the envelope. `level` is her instantaneous voice level, 0..1.
export function stepGlow(glow, level, dt) {
	return glow + (Math.max(0, Math.min(1, level)) - glow) * (1 - Math.exp(-dt / AURA_TAU));
}

export function auraOpacity(glow) {
	return AURA_BASE + AURA_SWING * glow;
}

// Counts flashes the way WCAG 2.3.1 does: a flash is a pair of opposing changes
// in relative luminance of at least 10%. Opacity stands in for luminance here -
// the aura's colour is fixed, so its brightness is proportional to its opacity.
export function countFlashes(values, threshold = 0.1) {
	let transitions = 0;
	let dir = 0; // 0 undecided, 1 last change was a rise, -1 a fall
	let peak = values[0];
	let trough = values[0];
	for (const v of values) {
		if (dir >= 0) peak = Math.max(peak, v);
		if (dir <= 0) trough = Math.min(trough, v);
		if (dir >= 0 && peak - v >= threshold) {
			transitions++;
			dir = -1;
			trough = v;
		} else if (dir <= 0 && v - trough >= threshold) {
			transitions++;
			dir = 1;
			peak = v;
		}
	}
	return transitions / 2;
}
